import React from 'react';
import { useHistory } from 'react-router-dom';

const FAQ_DATA = [
  {
    cat: '數位憑證卡片',
    items: [
      [
        '我如果忘記身份驗證識別碼怎麼辦？',
        '身份驗證識別碼會附在寄送數位 PDF 學位證書的 Email 中；若信件已刪除或無法找到，請向原發證學校洽詢確認。',
      ],
      [
        '我要怎麼把數位憑證卡片存到手機？',
        '請先下載數位發展部的「數位憑證皮夾」，完成裝置綁定後，即可使用 App 內的「掃描」功能掃描 QR Code，將憑證卡片加入手機皮夾。',
      ],
      [
        '使用數位憑證皮夾需要付費嗎？',
        '目前政府提供的數位憑證皮夾基本功能是免費的，可以安心使用。不過若未來使用其他廠商的服務或加值功能，則可能會依服務內容收費。',
      ],
      [
        '數位憑證皮夾安全嗎？',
        '整體來說是安全的，系統會透過加密與防護機制來保護資料，再搭配密碼或生物辨識等驗證方式，可以進一步提升安全性。建議避免在公共 Wi-Fi 操作敏感功能，並定期更新 App。',
      ],
      [
        '數位憑證皮夾會不會影響我的個人隱私？',
        '不會，數位憑證皮夾讓你可以自行決定要提供哪些資料，只揭露必要資訊，不需要一次提供全部內容，同時也有相關機制保障資料安全。',
      ],
    ],
  },
  {
    cat: '數位 PDF 證書',
    items: [
      [
        '驗證結果顯示失敗',
        '此證書非發行單位所發行的數位 PDF 證書，請洽原單位了解詳情。',
      ],
      [
        '驗證結果顯示警告',
        '此證書非最新版本，請使用最新版電子證書上傳驗證，或向原發證單位洽詢確認。',
      ],
      [
        '如果我的電子證書遺失了怎麼辦？',
        '請向原發證單位申請補發，待補發完畢，舊版證書將立即失效。',
      ],
    ],
  },
];

export const FAQPage: React.FC = () => {
  const history = useHistory();

  return (
    <>
      <h1>常見問題</h1>
      <p className="dc-lead">依服務類型查看操作問題與說明。</p>

      {FAQ_DATA.map((c, ci) => (
        <section key={c.cat} style={{ marginTop: ci === 0 ? '16px' : '28px' }}>
          <h2>{c.cat}</h2>
          {c.items.map((it, ii) => (
            <details
              key={ii}
              open={ci === 0 && ii === 0}
              style={{ borderBottom: '1px solid var(--dc-line)', padding: '14px 0' }}
            >
              <summary style={{ cursor: 'pointer', fontWeight: 550 }}>{it[0]}</summary>
              <p style={{ margin: '12px 0 0', fontSize: '14px', lineHeight: 1.65, color: 'var(--dc-muted)' }}>
                {it[1]}
              </p>
            </details>
          ))}
        </section>
      ))}

      <div className="dc-actions" style={{ marginTop: '28px' }}>
        <button
          type="button"
          className="dc-button"
          onClick={() => history.push('/about/contact')}
        >
          仍需協助？聯絡中心
        </button>
      </div>
    </>
  );
};

export default FAQPage;
